import type { CSSProperties } from 'react';
import type { ContactChannel } from '../../data/contact';
import { ContactActionButton } from './ContactActionButton';

interface ContactChannelCardProps {
  channel: ContactChannel;
  index: number;
}

export function ContactChannelCard({ channel, index }: ContactChannelCardProps) {
  return (
    <article
      className="contact-channel-card reveal-item"
      style={
        {
          '--contact-accent': channel.accent,
          transitionDelay: `${index * 0.08}s`,
        } as CSSProperties
      }
    >
      <span className="contact-channel-card__index">0{index + 1}</span>
      <p className="contact-channel-card__eyebrow">{channel.eyebrow}</p>
      <h3 className="contact-channel-card__title">{channel.title}</h3>
      <p className="contact-channel-card__value">{channel.value}</p>
      <div className="contact-channel-card__action">
        <ContactActionButton
          label={channel.action.label}
          sublabel={channel.action.sublabel}
          href={channel.action.href}
          icon={channel.action.icon}
        />
      </div>
    </article>
  );
}
